module.exports = __webpack_public_path__ + "static/media/expert-chat-fab-team.4c788773.png";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-WEB/expert-chat-fab-team.png
// module id = 1419
// module chunks = 0